"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewbuildingPromoCarousel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _swiper = _interopRequireDefault(require("swiper"));
var _modules = require("swiper/modules");
var _react2 = require("swiper/react");
var _useQueryManager = require("../../hooks/useQueryManager");
var _Arrow = require("./parts/Arrow");
var _Skeleton = require("../Skeleton");
var _NewbuildingCard = require("../NewbuildingCard");
require("swiper/css");
var styles = _interopRequireWildcard(require("./styles.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_swiper.default.use([_modules.Navigation]);
const NewbuildingPromoCarousel = exports.NewbuildingPromoCarousel = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    ids,
    fetchData,
    fetchStep = 5,
    slidesPerView = 5,
    onNewbuildingClick,
    onNewbuildingChange
  } = props;
  const swiper = React.useRef(null);
  const prevRef = React.useRef(null);
  const nextRef = React.useRef(null);
  const isUpdatingSlide = React.useRef(false);
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const {
    items
  } = (0, _useQueryManager.useQueryManager)({
    fetchData,
    ids,
    currentIndex,
    fetchStep
  });
  const setSwiper = React.useCallback(newSwiper => {
    swiper.current = newSwiper;
  }, []);
  const handleClick = React.useCallback((event, index, item) => {
    event.preventDefault();
    onNewbuildingClick({
      position: index,
      newbuilding: item
    });
    window.open(item.url, '_blank');
  }, [onNewbuildingClick]);
  const slides = React.useMemo(() => {
    return items.map((item, index) => /*#__PURE__*/React.createElement(_react2.SwiperSlide, {
      key: item.id
    }, _ref => {
      let {
        isVisible
      } = _ref;
      if (item.isLoaded) {
        return /*#__PURE__*/React.createElement(_NewbuildingCard.NewbuildingCard, (0, _extends2.default)({}, item, {
          onClick: event => handleClick(event, index, item)
        }));
      }
      return isVisible && /*#__PURE__*/React.createElement(_Skeleton.Skeleton, null);
    }));
  }, [items, handleClick]);
  const onSlideChange = swiper => {
    if (isUpdatingSlide.current) {
      return;
    }
    setCurrentIndex(swiper.realIndex);
    onNewbuildingChange({
      position: swiper.realIndex,
      step: fetchStep,
      newbuildings: items
    });
  };
  const resetCurrentSlide = React.useCallback(() => {
    isUpdatingSlide.current = true;
    if (swiper.current) {
      setCurrentIndex(0);
      swiper.current.slideTo(0);
    }
    isUpdatingSlide.current = false;
  }, []);
  React.useImperativeHandle(ref, () => ({
    resetCurrentSlide
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: styles['wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement(_react2.Swiper, {
    navigation: {
      prevEl: prevRef.current,
      nextEl: nextRef.current,
      disabledClass: 'newbuilding-promo-carousel-button-disabled'
    },
    "data-testid": "desktop_swiper",
    allowTouchMove: false,
    spaceBetween: 16,
    slidesPerView: slidesPerView,
    slidesPerGroup: slidesPerView,
    onSlideChange: onSlideChange,
    height: 314,
    watchSlidesProgress: true,
    onSwiper: setSwiper
  }, slides)), ids.length > slidesPerView && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Arrow.Arrow, {
    direction: -1,
    ref: prevRef
  }), /*#__PURE__*/React.createElement(_Arrow.Arrow, {
    direction: 1,
    ref: nextRef
  })));
});
NewbuildingPromoCarousel.displayName = 'NewbuildingPromoCarousel';